import { useContext } from "react";
import moment from "moment";
import { UserCtx } from "../../context/userContext";
import { getUserColor } from "../../utils/getUserColor";
import { Button } from "../ui/button";
import { Notification } from "../../models/app.interface";
import { NotificationCtx } from "../../context/notificationContext";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import useName from "../../hooks/useName";
import { cn } from "../../utils/cn";

type Props = {
  notification: Notification;
};

export function NotificationPageItem({ notification }: Props) {
  const { user } = useContext(UserCtx);
  const { markRead, markUnread } = useContext(NotificationCtx)
  const { initial } = useName({ firstName: notification.creator_first_name });

  const timezone = user.timezone.value;
  const notificationTime = moment
    .utc(notification.created_at)
    .tz(timezone)
    .format("lll");

  return (
    <div className="border-border relative flex items-center justify-between gap-2 border-b py-5 last:border-0 flex-wrap">
      <div className="flex items-center gap-[20px]">
        <Avatar size="xs" className={cn({
          "ring-ring ring-2 ring-orange ring-offset-2": notification.viewed === 0,
        })}>
          {Boolean(notification.creator_has_avatar) && (
            <AvatarImage
              alt="avatar"
              src={`https://profile-avatars-${process.env.REACT_APP_USER_ENVIRONMENT}.s3.amazonaws.com/${notification.creator_user_id}`}
            />
          )}
          <AvatarFallback
            className={getUserColor(notification.creator_user_color)}
          >
            {initial}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col gap-0.5">
          <h3
            className={cn({
              "text-muted-foreground": notification.viewed === 1,
              "font-semibold": notification.viewed === 0,
            })}
          >
            {notification.notification_name}
          </h3>
          <p className="text-muted-foreground text-sm">{notificationTime}</p>
        </div>
      </div>

      <Button
        onClick={() => {
          if (notification.viewed === 0) {
            markRead(notification.id)
          } else {
            markUnread(notification.id)
          }
        }}
        variant="secondary"
        size="sm"
      >
        {notification.viewed === 0 ? "Mark as read" : "Mark as unread"}
      </Button>
    </div>
  );
};